var toInteger = value => parseInt(value, 10);
var toIntegerOrNull = value => toInteger(value) || null;
export { toInteger, toIntegerOrNull };